// app/providers.tsx
"use client";
import * as posthog from "@lib/posthog";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";

export function PHProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    posthog.init();
  }, []);

  return <PostHogProvider client={posthog.client}>{children}</PostHogProvider>;
}
